"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createPaymentRequestFunction = void 0;
var _mercadopago = require("./mercadopago");
var _cielo = require("./emv3ds/cielo");
const createPaymentRequestFunction = async ({
  mercadoPagoPublicKey,
  emv3dsAccessToken,
  emv3dsEnvironment,
  locale
}) => {
  const fn = async ({
    creditCard,
    totalValue,
    currency,
    installments,
    identificationType,
    identificationNumber,
    orderNumber,
    merchantUrl
    // deviceIpAddress,
  }) => {
    let _outputCreditCard = creditCard;
    let secretAuthenticationData;
    let secretDeviceId;
    if (mercadoPagoPublicKey) {
      const mp = await (0, _mercadopago.configMercadoPago)({
        publicKey: mercadoPagoPublicKey,
        locale
      });
      const token = await mp.createCardToken({
        securityCode: creditCard.cvv,
        cardNumber: creditCard.number,
        cardExpirationMonth: creditCard.expiryDate.substring(0, 2),
        cardExpirationYear: creditCard.expiryDate.length === 4 ? '20' + creditCard.expiryDate.substring(2) : creditCard.expiryDate.substring(2),
        cardholderName: creditCard.holder,
        identificationType,
        identificationNumber
      });
      secretDeviceId = await (0, _mercadopago.getDeviceId)();
      _outputCreditCard = {
        brand: creditCard.brand,
        token: token.id
      };
    }
    if (emv3dsAccessToken) {
      secretAuthenticationData = await (0, _cielo.authenticate)({
        accessToken: emv3dsAccessToken,
        environment: emv3dsEnvironment,
        cardExpiryDate: creditCard.expiryDate,
        cardNumber: creditCard.number,
        currency: currency,
        orderNumber: orderNumber,
        installments,
        paymentMethod: 'Credit',
        totalValue,
        merchantUrl
        // deviceIpAddress,
      });
    }

    return {
      installments,
      creditCard: _outputCreditCard,
      secretAuthenticationData,
      secretDeviceId,
      currency,
      value: totalValue
    };
  };
  return fn;
};
exports.createPaymentRequestFunction = createPaymentRequestFunction;
var _default = createPaymentRequestFunction;
exports.default = _default;